var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddProgramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1695_143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58813 5.18945H19.9006V6.7207H4.58813V5.18945Z",
    fill: "#80808F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9631 8.25195H37.51V9.7832H22.9631V8.25195Z",
    fill: "#80808F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4319 31.2207H19.9006V29.6895H21.4319V31.2207ZM18.3694 31.2207H4.58813V29.6895H18.3694V31.2207Z",
    fill: "#80808F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.00561523 0.595703V49.3927L3.40306 47.4181L6.04723 48.9493L8.6858 47.4181L11.324 48.9493L13.9618 47.4181L16.5978 48.9493L19.2352 47.4181L21.873 48.9493L24.5105 47.4181L27.1457 48.9493L29.7827 47.4181L32.4179 48.9493L35.0539 47.4181L37.6868 48.9493L40.3235 47.4181L42.9557 48.9493L45.5936 47.4181L48.9944 49.3942V0.595703H-0.00561523ZM47.4631 46.7347L45.5936 45.6483L42.9557 47.1796L40.3235 45.6483L37.6868 47.1796L35.0539 45.6483L32.4179 47.1796L29.7827 45.6483L27.1457 47.1796L24.5105 45.6483L21.873 47.1796L19.2352 45.6483L16.5978 47.1796L13.9618 45.6483L11.324 47.1796L8.6858 45.6483L6.04574 47.1796L3.40306 45.6483L1.52563 46.7362V2.12695H47.4631V46.7347Z",
    fill: "#80808F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4319 8.25195H4.58813V28.1582H21.4319V8.25195ZM12.2444 26.627H6.11938V26.2509C6.11901 25.9092 6.34556 25.6086 6.67454 25.5144L10.8204 24.3301H12.2444V26.627ZM9.5647 14.377C10.1643 13.4229 11.2126 12.8446 12.3393 12.8457H14.5413C14.9641 12.8457 15.3069 13.1885 15.3069 13.6113V19.333L13.7756 20.502H12.2519L10.7206 19.333V15.9082H13.7831V14.377H9.5647ZM12.2444 22.0332H13.7756V22.8179L12.2444 22.8082V22.0332ZM19.9006 26.627H13.7756V24.3301H15.1996L19.3447 25.5144C19.6737 25.6082 19.9006 25.9088 19.9006 26.2509V26.627ZM19.9006 24.0927C19.8554 24.0766 19.8124 24.0553 19.7661 24.0422L15.5166 22.8287H15.3069V21.259L16.8381 20.0922V13.6113C16.8381 12.3429 15.8097 11.3145 14.5413 11.3145H12.3386C10.1314 11.3122 8.20691 12.8147 7.67344 14.9564L7.43568 15.9082H9.18188V20.0907L10.7131 21.2575V22.7988L6.25322 24.0422C6.20649 24.0553 6.16462 24.0766 6.11938 24.0927V9.7832H19.9006V24.0927Z",
    fill: "#80808F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4006 32.752H4.58813V41.9395H44.4006V32.752ZM42.8694 40.4082H6.11938V34.2832H42.8694V40.4082Z",
    fill: "#80808F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4006 11.3145H22.9631V17.4395H44.4006V11.3145ZM42.8694 15.9082H24.4944V12.8457H42.8694V15.9082Z",
    fill: "#80808F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4006 18.9707H22.9631V28.1582H44.4006V18.9707ZM42.8694 26.627H24.4944V20.502H42.8694V26.627Z",
    fill: "#80808F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1695_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    transform: "translate(-0.00561523 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProgramIcon);
export default __webpack_public_path__ + "static/media/add-program-icon.0561cfe2626aefaf7fcd5bfd17eeb44f.svg";
export { ForwardRef as ReactComponent };